import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: "form-number-block",
  type: "FormNumberBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: "Number",
    },
    placeholder: {
      prop: "other",
      type: "string",
      value: "",
    },
    required: {
      prop: "other",
      type: "boolean",
      value: false,
    },
  },
};
